import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";

import { EventStatus } from "../../events-screen/event-page-models/event-status";
import { eventPageUtils } from "../../events-screen/utils/event-page-utils";
import { getEnumNumbers } from "../../../_helpers/enum-utils";
import { ChildEvent } from "../../events-screen/event-page-models/child-event";
import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";
import { trimTextByWord } from "../../events-screen/utils/trimTextByWord";
import { PaperPaymentItem } from "../receipt-page-models/PaperPaymentItem";
import { Epoc } from "../../../_models/Epoc";
import { RowEventEmit } from "../../events-screen/event-page-models/row-event-emit";
import { PaperPaymentType } from "../receipt-page-models/PaperPaymentType";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { ReceiptTableRowComponent } from "../receipt-table-row/receipt-table-row.component";
import { ReceiptTableRowHeader } from "../receipt-table-row-header/receipt-table-row-header.component";
import { GeneralRowEvent } from "../../../_models/general-row-event";
import { DepositRowAction } from "../receipt-page-models/DepositRowAction";
import { DateAndTimeUtils } from "../../../_helpers/dateUtils";

@Component({
  selector: "receipt-table-row-details-child-receipt-row",
  templateUrl: "./receipt-table-row-details-child-receipt-row.component.html",
  styleUrls: [
    "../receipt-table-row/receipt-table-row.component.scss",
    "./receipt-table-row-details-child-receipt-row.component.scss",
  ],
})
// remove
export class ReceiptTableRowDetailsChildReceiptRowComponent {
  @Input() public paymentItem: PaperPaymentItem;
  @Input() public rowNumber: number;
  @Input() public totalItemsInBatch: number;

  @Output("rowEvent") public rowEvent: EventEmitter<
    GeneralRowEvent<DepositRowAction>
  > = new EventEmitter<GeneralRowEvent<DepositRowAction>>();
  public translations$: Observable<ITranslations>;
  public ReceiptTableRowMenuOptions =
    ReceiptTableRowComponent.ReceiptTableRowMenuOptions;
  public customActionWithoutDeposit =
    ReceiptTableRowComponent.ReceiptTableRowMenuOptions.filter(
      (option) => option.action !== "deposit"
    );
  public readonly PaperPaymentType = PaperPaymentType;
  public batchPaymentHeader = ReceiptTableRowHeader.BatchPaymentHeader;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }

  public stringFromEpoc(epoc: Epoc) {
    const date = DateAndTimeUtils.serverEpochToDate(epoc);
    return this.formatDate(date);
  }

  public formatDate(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }

  public rowClicked($event): void {}

  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }

  public menuEventHandler($event: RowEventEmit) {
    this.rowEvent.emit({
      action: $event.action as any,
      eventId: this.paymentItem.id.toString(),
      eventObject: {
        depositActionType: "depositItem",
        batchId: null,
        paymentItemId: this.paymentItem.id,
      },
    });
  }

  protected batchDepositClicked($event: MouseEvent) {
    $event.stopPropagation();
    this.rowEvent.emit({
      action: "edit" as any,
      eventId: this.paymentItem.id.toString(),
      eventObject: {
        depositActionType: "depositItem",
        batchId: null,
        paymentItemId: this.paymentItem.id,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-table-row-details-child-receipt-row/receipt-table-row-details-child-receipt-row.component.ts